// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__3QouH","avatar":"Pill_avatar__3sfoJ"};